import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams, updateWidgetSettings } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import "./settings.less";
import { useIntl } from "react-intl";
import { Input, Message, Switch, Button } from "../../../BP2Components";
import SimpleSelect from "../../../BP2Components/Select/SimpleSelect";
import { useSelector } from "react-redux";
import { isShortGUID } from "../../../../util/Scripts";

const ListUrlSettings = (props) => {
   const { allLanguages } = useSelector(({ settings }) => settings);

   const [settings, setSettings] = useState(() => {
      const base = {
         mapLocalizationFieldName: props.localizationFieldName,
         mapClickFilterColName: props.mapClickFilterColName,
         mapDefaultZoomLevel: props.defaultZoomLevel,
         mapViewListSerie: props.viewListSerie,
         mapListSerie: props.mapListSerie,
         mapIndependentSerie: props.mapIndependentSerie,
         mapPointColName: props.mapPointColName,
         mapDistanceColName: props.mapDistanceColName,
         mapAddressColName: props.mapAddressColName,
         showMap: props.showMap,
         showListName: props.showListName,
         filterByLocation: props.filterByLocation,
         distanceToFilter: props.distanceToFilter,
         maxDistanceToFilter: props.maxDistanceToFilter,
         setDistanceColumnHidden: props.setDistanceColumnHidden,
         name: props.name,
         columnProperties: props.columnProperties,
         selectedSerie: props.selectedSerie,
         listWidgetSeries: props.listWidgetSeries,
         priority: props.priority,
         stateChange: 0,
         id: props.id,
         xsWidth: props.xs,
         smWidth: props.sm,
         mdWidth: props.md,
         lgWidth: props.lg,
         xlWidth: props.xl,
         backgroundColourHex: props.backgroundColourHex,
         showPlacefinder: props.showPlacefinder,
         showUrlButton: props.showUrlButton,
         urlColumn: props.urlColumn,
         ulrButtonTitle: props.ulrButtonTitle,
      };

      allLanguages?.forEach((lang) => {
         base[`name${lang.language}`] =
            props?.board?.translations?.find((t) => t.key === props?.ulrButtonTitle)?.values?.[
               lang.language
            ] ?? "";
      });

      return base;
   });

   const dispatch = useDispatch();
   const intl = useIntl();

   const handleSubmit = (e) => {
      e.preventDefault();

      const updatedBoard = { ...props.board };

      const existingTranslation = updatedBoard.translations?.find(
         (t) => t.key === settings.ulrButtonTitle,
      );

      const newValues = allLanguages.reduce((acc, lang) => {
         acc[lang.language] = settings[`name${lang.language}`] || "";
         return acc;
      }, {});

      if (existingTranslation) {
         existingTranslation.values = newValues;
      } else {
         updatedBoard.translations.push({
            category: null,
            key: settings.ulrButtonTitle,
            values: newValues,
         });
      }

      dispatch(setWidgetInSheetParams(settings));
      dispatch(updateWidgetSettings(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChangeInput = (event, name) => {
      setSettings((prev) => ({
         ...prev,
         [name]: event.target.value,
      }));
   };

   const handleChange = (e) => {
      let saveValue = e.target.value;
      if (Number.isInteger(+e.target.value)) {
         saveValue = +e.target.value;
      }
      setSettings({ ...settings, [e.target.name]: saveValue });
   };
   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };
   const handleSelect = (option) => {
      setSettings((prev) => ({
         ...prev,
         urlColumn: option.value,
      }));
   };

   const createSelectOptions = (columns) => {
      const options = columns
         ?.filter(
            (column) => typeof column?.title === "string" && typeof column?.techName === "string",
         )
         .map((column) => ({
            label: column.title,
            value: column.techName,
         }));
      return options;
   };

   const selectOptions = createSelectOptions(props?.columns);
   const selectedOption = selectOptions?.find((opt) => opt.value === settings.urlColumn) ?? null;

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="showMap" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showUrlButton" />:
                     <Switch
                        name="showMap"
                        onChange={(e) => handleSwitch(e, "showUrlButton")}
                        defaultChecked={props.showUrlButton}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="urlColumn">
                     <IntlMessages id="settings.urlColumn" />:
                     <div style={{ width: "200px" }}>
                        <SimpleSelect
                           style={{ borderRadius: "12px" }}
                           options={selectOptions}
                           value={selectedOption}
                           onChange={handleSelect}
                        />
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="ulrButtonTitle">
                     <IntlMessages id="settings.ulrButtonTitle" />:
                     <Input
                        type="text"
                        name="ulrButtonTitle"
                        style={{ width: "200px" }}
                        onChange={handleChange}
                        defaultValue={props.ulrButtonTitle}
                        disabled={isShortGUID(props.ulrButtonTitle)}
                     />
                     {allLanguages?.map((item) => (
                        <>
                           <span style={{ marginLeft: "10rem" }}>
                              <IntlMessages id={`${item.language}`} />:
                           </span>
                           <Input
                              style={{ width: "200px", marginLeft: "1rem", marginTop: "1rem" }}
                              type="translation"
                              name={`name${item.language}`}
                              value={settings[`name${item.language}`] || ""}
                              onChange={(e) => handleChangeInput(e, `name${item.language}`)}
                           />
                        </>
                     ))}
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ListUrlSettings;
